<!-- @if(authStore.isLoading()){
<p-progress-spinner ariaLabel="loading" /> -->
<!-- } -->

@if (authStore.isAuthenticated()) {
  <div class="min-h-screen flex flex-col">
    <div class="flex flex-1 md:flex-row flex-col">
      <!-- Sidenav for medium and larger screens -->
      <div class="w-20 box-border hidden md:block">
        <app-sidenav></app-sidenav>
      </div>
      <!-- ToolbarSidebar for small screens -->
      <div class="block md:hidden w-full sticky top-0 z-[10] mb-2">
        <app-toolbar-sidebar [mainPage]="'body'"></app-toolbar-sidebar>
      </div>
      <main id="main-scroll-container" class="overflow-auto w-full px-10 py-5  md:p-15 md:pl-17 md:pb-5 z-[0] flex flex-col flex-1">
        <app-breadcrumb></app-breadcrumb>
        <router-outlet />
      </main>
    </div>
  </div>
} @else if (authStore.isPasswordChangeNeeded()) {
  <app-change-password></app-change-password>
} @else if(!authStore.isAuthenticated()){
  <router-outlet />
}

<p-toast position="top-right"></p-toast>
